import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SegmentGroupStatsResponseDataSchema } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof SegmentGroupStatsResponseDataSchema>>

type Options = {
  id: string
  onSuccess?: (data: z.infer<typeof SegmentGroupStatsResponseDataSchema>) => void
}

function getSegmentGroupStatsQueryKey(id: string) {
  return ["segment-group-stats", id]
}

export function segmentGroupStatsQuery({ id, onSuccess }: Options) {
  return queryOptions({
    queryKey: getSegmentGroupStatsQueryKey(id),
    queryFn: async (): Promise<z.infer<typeof SegmentGroupStatsResponseDataSchema>> => {
      const response = await axios.get<Response>(`/segments/groups/${id}/stats`)

      onSuccess?.(response.data.data)

      return response.data.data
    },
  })
}
